// extracted by mini-css-extract-plugin
export default {"wrapper":"helpDocuments_wrapper__2f36V","teamViewer":"helpDocuments_teamViewer__uQyi0","itemWrapper":"helpDocuments_itemWrapper__jB033"};